<template>
    <WebSocketLoadingModal
        :title="__('customers.invoices.invoice_preview_notice')"
        :show-modal="showModal"
        :internal-support-link="internalSupportLink"
        :soft-timeout="180"
        @close="closeModal"
    />
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import WebSocketLoadingModal from '~@/Components/Common/Modals/WebSocketLoadingModal'
import { usePage } from '@inertiajs/vue3'

const props = defineProps({
    customer: {
        type: Object,
        default: () => ({})
    },
    showModal: {
        type: Boolean,
        default: false
    },
    internalSupportLink: {
        type: String,
        default: () => { return '' }
    }
})

const emit = defineEmits(['closeModal', 'previewReady'])

const closeModal = () => {
    emit('closeModal')
}

window.laravelEcho
    .private(`onecrm.customers.invoice.preview.${usePage().props.auth.user.id}`)
    .listen(
        '.customers.invoice_preview_ready',
        ({ creditNote, error, customerId, hasPartnerItems, invoices, isVatValid, tenant }) => {
            if (tenant !== usePage().props.tenant) {
                return
            }
            if (customerId !== props.customer.id) {
                return
            }
            emit('previewReady', { creditNote, error, hasPartnerItems, invoices, isVatValid })
        }
    )

</script>
